export default __webpack_public_path__ + "static/media/download.7834e83d.svg";